import { logEvent } from 'commons/utils/tracking';
import { MENU_PRIMARY_TIKTOK_CLICK } from 'config/trackingEvents';

export const menuPrimaryTikTokClick = () => {
  logEvent(MENU_PRIMARY_TIKTOK_CLICK, {});
};
